export default __webpack_public_path__ + "static/media/Raseet-final-logo.15493f68.jpg";